import isBrowser from './isBrowser';
import { getSearchString } from './getSearchString';

const E2E_TESTING_PARAM = 'cypress-testing';
const E2E_TESTING_COOKIE = `triad_qs_${E2E_TESTING_PARAM}`;

/**
 * Checks if the application is running in an end-to-end testing environment.
 *
 * @return {boolean} Returns true if the application is running in an end-to-end testing environment,
 * otherwise returns false.
 */
export function isEnd2EndTesting(): boolean {
  try {
    // Currently no need to support server side
    if (!isBrowser()) return false;

    const searchString = getSearchString();
    const testParam = new URLSearchParams(searchString);
    const testCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${E2E_TESTING_COOKIE}=`))
      ?.split('=')[1];

    return testParam.get(E2E_TESTING_PARAM) === 'true' || testCookie === 'true';
  } catch (__error) {
    return false;
  }
}
